import React, { useState, useEffect, useRef } from 'react';
import { shape } from 'prop-types';
import TextArea from 'devextreme-react/text-area';
import { Spinner } from '@core/components';

export const withGridInfoBar = (
  WrappedComponent,
  rowValueToPreview,
  textAreaHeight = '100%'
) => {
  const _withGridInfoBar = (props) => {
    const spinnerRef = useRef(null);

    const [dataGridHeight, setDataGridHeight] = useState(0);
    const [barFocusedRow, setBarFocusedRow] = useState({});

    useEffect(() => {
      const { clientHeight } = spinnerRef.current;

      setDataGridHeight(clientHeight - 105);
    }, [setDataGridHeight]);

    const determineTextAreaValue = () => {
      const { currentRowData } = props;

      if (currentRowData) {
        return currentRowData[rowValueToPreview];
      }

      return barFocusedRow[rowValueToPreview];
    };

    if (dataGridHeight === 0) {
      return (
        <div className="grid-info-bar-spinner" ref={spinnerRef}>
          <Spinner />
        </div>
      );
    }

    return (
      <div className="grid-info-bar">
        <WrappedComponent
          {...props}
          dataGridHeight={dataGridHeight}
          setBarFocusedRow={setBarFocusedRow}
          barFocusedRow={barFocusedRow}
        />
        <div className="grid-info-bar__textarea">
          <TextArea
            height={textAreaHeight}
            readOnly
            value={determineTextAreaValue()}
          />
        </div>
      </div>
    );
  };

  _withGridInfoBar.propTypes = {
    currentRowData: shape({})
  };

  return _withGridInfoBar;
};
